import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const EASE_TOKENS = ["standard", "enter", "exit", "sheet"];

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ["control", "card", "sheet", "badge", "game-sheet", "game-dialog", "game-ticket", "game-ticket-inner", "game-window", "game-strip"],
      shadow: [
        "card",
        "card-hover",
        "inset",
        "raised",
        "float",
        "overlay",
        "bar",
        "bar-up",
        "sticky",
        "game-sheet",
        "game-dialog",
        "game-button",
        "game-ticket",
        "game-ticket-edge",
        "game-window",
        "game-notch-left",
        "game-notch-right",
        "game-hub",
        "game-hub-gloss",
        "night-glow",
      ],
      ease: EASE_TOKENS,
      text: ["3xs", "2xs", "headline", "game-micro", "game-eyebrow", "game-title"],
      spacing: [
        "header",
        "header-gap",
        "container",
        "game-hairline",
        "game-rim",
        "game-edge",
        "game-coin",
        "game-notch-inset",
        "game-confetti",
        "game-confetti-offset",
        "game-strip-offset-x",
        "game-strip-offset-y",
      ],
      tracking: ["label", "game-display", "ticket", "ticket-stub"],
      aspect: ["banner", "wide", "tile", "ticket"],
      container: ["shell"],
    },
    classGroups: {
      duration: [{ duration: ["none", "instant", "fast", "base", "moderate", "slow", "entrance", "emphasis"] }],
      z: [{ z: ["raised", "raised-2", "raised-3", "sticky", "sticky-raised"] }],
      pb: [{ pb: ["safe", "safe-sm", "safe-lg"] }],
      h: [{ h: ["map", "fade", "game-grabber", "game-notch", "game-strip"] }],
      w: [{ w: ["suggestion", "combo", "game-dialog", "game-notch", "game-strip"] }],
      "min-h": [{ "min-h": ["empty", "fill"] }],
      "max-h": [{ "max-h": ["sheet", "sheet-sm", "game-sheet", "game-dialog"] }],
      "max-w": [{ "max-w": ["game-wheel", "game-ticket", "shell", "detail", "form"] }],
      "font-family": [{ font: ["game-display", "game-body"] }],
    },
  },
});

/**
 * Conditional classes with Tailwind conflict resolution: the last class of a group wins, so a call
 * site `className` overrides defaults. Every custom token of tailwind.config.ts (radius, shadow, ease,
 * duration, z, spacing, tracking, aspect, sizes, `pb-safe`) is registered.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
